export default __webpack_public_path__ + "02cfbdb387f3682faf892083cfed7daa.svg";